<div class="row">
  <div class="fill_scroll">
    <div class="row">
      <br/>
      <div class="input-group">
        <mat-form-field class="form-element">
          <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
          <input inputrestriction="basic1" matInput type="text" (keydown.control.a)="itemAllSelected()" name="SearchDualList" class="form-control" [(ngModel)]="filter" placeholder="" autocomplete="off"/>
          <a matSuffix aria-label="Clear" (click)="filter=''">
            <mat-icon>close</mat-icon>
          </a>
        </mat-form-field>
      </div>
    </div>
    <ul class="list-group">
      <br/>

      @for (item of list ; track item; let index = $index) {
        <li #simpleItem
          data-id="simple_id:{{getContentId(item,index)}}"
          [class.hidden]="item | FilterPipe:filter:content"
          class="list-group-item" (click)="itemSelected(item, index)"
          [ngClass]="{active: isActive(index,item)}">
          <!--      <li #simpleItem *ngFor="let item of list ; let index = index"-->
          <!--          data-id="simple_id:{{getContentId(item,index)}}"-->
          <!--          [class.hidden]="item | FilterPipe:filter:content"-->
          <!--          class="list-group-item" (click)="itemSelected(item, index)" [class.active]="getMetadata(index,item).selected">-->
          <!--(mouseover)="hover.next(item)" (mouseout)="hover.next(null)">-->
          <!-- {{getContent(item) | json}} -->
          <!--<span *ngIf="!m_editing" class="li-content pull-left">{{getContent(item)}}</span>-->
          @if (m_icon || m_iconCallback) {
            <span>
              <button [matTooltip]="tooltip" mat-button (click)="onIconClick($event, index)">
                <mat-icon>{{renderIcon(index, item)}}</mat-icon>
              </button>
            </span>
          }
          <app-simple-list-editable  [item]="item" (editChange)="onEditChanged($event)" [content]="content" [editable]="editable"></app-simple-list-editable>
        </li>
      }
    </ul>
  </div>
</div>
